<template lang="pug">
v-tabs(
  v-bind="extendAttrs"
  v-on="extendListeners"
)
  template(
    v-for="(_, name) in $scopedSlots"
    v-slot:[name]="data"
  )
    slot(:name="name" v-bind="data")
  template(
    v-for="(_, name) in $slots"
    :slot="name"
  )
    slot(:name="name")
</template>

<script>
import { VTabs } from 'vuetify/lib';

export default {
  components:  { VTabs },
  props: {
    bordered: {
      type: Boolean,
      default: false,
    },
    buttons: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: Number,
      default: 24,
    },
  },
  data() {
    return {};
  },
  computed: {
    extendAttrs() {
      const { bordered, buttons } = this;
      return {
        ...!buttons ? {
          height: 26,
        } : {
          hideSlider: true,
          height: 'unset',
        },
        nextIcon: '$ui-chevron-right',
        prevIcon: '$ui-chevron-left',
        class: [
          'dv-tabs',
          ...bordered ? ['dv-tabs--bordered'] : [],
          ...buttons ? ['dv-tabs--buttons'] : [],
        ],
        ...this.$attrs,
      };
    },
    extendListeners() {
      return {
        change: (val) => {
          this.$emit('input', val);
          this.$emit('change', val);
        },
        ...this.$listeners,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dv-tabs {
  $gap: calc(v-bind(gap) * 1px);
  &::v-deep .v-slide-group__content {
    gap: #{$gap};
  }
  &--bordered {
    &::v-deep .v-slide-group__content {
      border-bottom: 1px solid #{$ui-neutral-lighten3};

      & > .v-tab {
        white-space: nowrap !important;
        overflow: hidden;
        text-overflow: ellipsis;

        & * {
          max-width: 100%;
        }
      }
    }
  }
  &--buttons {
    padding: 4px;
    border-radius: 12px;
    width: fit-content;
    background-color: #{$ui-neutral-lighten4};

    &::v-deep .v-tab {
      transition: background-color 100ms ease-in;
      padding: 10px 16px;
      border-radius: 8px;

      white-space: nowrap !important;
      display: block;
      display: -webkit-box;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;

      &.v-tab--active {
        background-color: #{$ui-bright};
      }
    }
  }
  &::v-deep .v-slide-group {
    &__prev,
    &__next {
      z-index: 1;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      & .v-icon {
        padding: 6px;
        background-color: #{$ui-bright};
        border: 1px solid #{$ui-neutral-lighten4};
        border-radius: 50%;
        &__component {
          width: 20px !important;
          height: 20px !important;
          font-size: 20px !important;
        }
      }
    }
    &__prev {
      left: 0px;
    }
    &__next {
      right: 0px;
    }
  }
}
</style>
